<template>
  <b-row>
    <b-col lg="12">
      <!-- .name -->
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row>
            <!-- .title -->
            <b-col lg="12"
              ><b-form-group
                id="input-group-1"
                :label="$t('online_session.title')"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="newItem.title"
                  type="text"
                  :placeholder="$t('online_session.title')"
                />
              </b-form-group>
              <!-- .description --> </b-col
            ><b-col lg="12"
              ><b-form-group
                id="input-group-2"
                :label="$t('online_session.description')"
                label-for="input-2"
              >
                <ckeditor :config="{ contentsLangDirection : 'rtl',versionCheck : false}"    id="textarea-2" v-model="newItem.description" />
              </b-form-group>
              <!-- .start_in -->
            </b-col>
            <b-col lg="6"
              ><b-form-group
                id="input-group-5"
                :label="$t('edu_programs.edu_programs')"
                label-for="input-5"
              >
                <v-select
                  dir="rtl"
                  id="input-30"
                  v-model="eduProgram"
                  :reduce="(eduProgram) => eduProgram.id"
                  label="name"
                  :options="eduPrograms"
                  @input="selectRoom(eduProgram)"
                />
              </b-form-group>
              <!-- .api_category -->
            </b-col>
            <b-col lg="6"
              ><b-form-group
                id="input-group-5"
                :label="$t('rooms.rooms')"
                label-for="input-5"
              >
                <v-select
                  dir="rtl"
                  id="input-30"
                  v-model="newItem.room_id"
                  :reduce="(rooms) => rooms.id"
                  label="name"
                  :options="rooms"
                />
              </b-form-group>
              <!-- .api_category -->
            </b-col>

            <b-col lg="6"
              ><b-form-group
                id="input-group-6"
                :label="$t('online_session.api_category')"
                label-for="input-6"
              >
                <div class="demo-inline-spacing">
                  <b-form-radio
                    v-model="newItem.api_type"
                    name="some-radio9"
                    value="general-online_class"
                    class="custom-control-success"
                  >
                    {{ $t("online_session.online_class_time") }}
                  </b-form-radio>
                  <b-form-radio
                    v-model="newItem.api_type"
                    name="some-radio9"
                    value="zoom"
                    class="custom-control-info"
                  >
                    {{ $t("online_session.zoom") }}
                  </b-form-radio>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <b-row v-if="newItem.api_type == 'general-online_class'">
            <b-col lg="6"
              ><b-form-group
                id="input-group-3"
                :label="$t('online_session.start_in')"
                label-for="input-3"
              >
                <flat-pickr
                  v-model="newItem.start_in"
                  class="form-control"
                  :config="{ enableTime: true, dateFormat: 'Y-m-d H:i' }"
                />
              </b-form-group>
            </b-col>
            <b-col lg="6"
              ><b-form-group
                id="input-group-3"
                :label="$t('online_session.duration')"
                label-for="input-3"
              >
                <b-form-input
                  id="input-1"
                  v-model="duration"
                  min="30"
                  type="number"
                  :placeholder="$t('online_session.duration')"
                />
              </b-form-group>
            </b-col>
            <b-col lg="12"
              ><b-form-group>
                <div class="demo-inline-spacing">
                  <b-form-checkbox
                    v-model="newItem.outo_recording"
                    value="1"
                    class="custom-control-primary"
                  >
                    {{ $t("online_session.outo_recording") }}
                  </b-form-checkbox>
                  <b-form-checkbox
                    v-model="newItem.listenOnlyMode"
                    value="1"
                    class="custom-control-secondary"
                  >
                    {{ $t("online_session.listenOnlyMode") }}
                  </b-form-checkbox>
                  <b-form-checkbox
                    v-model="newItem.disableCam"
                    value="1"
                    class="custom-control-success"
                  >
                    {{ $t("online_session.disableCam") }}
                  </b-form-checkbox>

                  <b-form-checkbox
                    v-model="newItem.lockOnJoin"
                    value="1"
                    class="custom-control-danger"
                  >
                    {{ $t("online_session.lockOnJoin") }}
                  </b-form-checkbox>

                  <b-form-checkbox
                    v-model="newItem.disableMic"
                    value="1"
                    class="custom-control-warning"
                  >
                  </b-form-checkbox>
                  <b-form-checkbox
                    v-model="newItem.webcamsOnlyForTeacher"
                    value="1"
                    class="custom-control-info"
                  >
                    {{ $t("online_session.webcamsOnlyForTeacher") }}
                  </b-form-checkbox>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="newItem.api_type == 'zoom'">
            <b-col lg="4"
              ><b-form-group
                id="input-group-3"
                :label="$t('meetings.start_time')"
                label-for="input-3"
              >
                <b-form-datepicker
                  id="example-datepicker"
                  v-model="newItem.start_time"
                  class="mb-1"
                />
              </b-form-group>
            </b-col>
            <b-col lg="4"
              ><b-form-group
                id="input-group-1"
                :label="$t('meetings.duration')"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="newItem.duration"
                  type="number"
                  :placeholder="$t('meetings.duration')"
                />
              </b-form-group>
              <!-- .description -->
            </b-col>
            <b-col lg="4"
              ><b-form-group
                id="input-group-1"
                :label="$t('meetings.password')"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="newItem.password"
                  type="text"
                  :placeholder="$t('meetings.password')"
                />
              </b-form-group>
              <!-- .description -->
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col lg="6">
              <b-button
                block
                :disabled="invalid"
                variant="primary"
                @click="submit()"
              >
                <i class="fa fa-plus" /> {{ $t("site.save") }}
              </b-button>
            </b-col>
            <b-col lg="6">
              <b-button block @click="goToTable()" variant="success">
                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-col>
  </b-row>
</template>

<script>
import Select2 from "v-select2-component";
import Controller from "../../../../Controllers/OnlineSessionController";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import flatPickr from "vue-flatpickr-component";
import { Arabic } from "flatpickr/dist/l10n/ar.js";
import EduProgramsController from "@/Controllers/EduProgramsController";
import vSelect from "vue-select";

var dates = [];

export default {
  name: "OnlineSessionForm",
  components: {
    Select2,
    ValidationProvider,
    ValidationObserver,
    required,
    flatPickr,
    vSelect,
  },
  props: ["newItem"],

  data() {
    return {
      file: {},
      rangeDate: "",
      date: "",
      eduPrograms: [],
      eduProgram: 0,
      duration: 30,
      rooms: [],
      teachers: [],
    };
  },
  created() {
    this.newItem.api_type = "general-online_class";
    new EduProgramsController()
      .GetAll({ with: ["rooms", "teachers"] })
      .then((res) => {
        this.eduPrograms = res;
      });
  },
  methods: {
    async goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      let endIn = new Date(this.newItem.start_in);
      endIn.setMinutes(this.duration);

      //2022-07-01 12:00
      this.newItem.end_in =
        endIn.getFullYear() +
        "-" +
        (parseInt(endIn.getMonth()) + 1) +
        "-" +
        endIn.getDate() +
        " " +
        endIn.getHours() +
        ":" +
        endIn.getMinutes();

      console.log(this.newItem.start_in, this.newItem.end_in);
      let ret = await new Controller().From(this.newItem, "FormData");
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
    },
    selectRoom(id) {
      let ed = this.eduPrograms.find((a) => a.id == id);
      this.rooms = ed.rooms;
      console.log(ed);
      this.teachers = ed.teachers;
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
